module.exports = __webpack_public_path__ + "static/web-dark-353407917dad5df6743c56f75e56ff5d.svg";